import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M12 3.75c-4.549 0-8.25 3.701-8.25 8.25s3.701 8.25 8.25 8.25 8.25-3.701 8.25-8.25S16.549 3.75 12 3.75zm3.609 8.766H12a.516.516 0 0 1-.516-.516V7.359a.516.516 0 1 1 1.032 0v4.125h3.094a.516.516 0 1 1 0 1.032z"
}), 'ClockFilled');